module.exports = __webpack_public_path__ + "media/site/images/icons/pencil-icon-0a1b3b9280c44579f2f4f26e66cead8b.svg";